

























































































































































































import Tooltip from "@/components/utility/tooltip.vue";
import { dataURItoBlob } from "@/lib/files/imageResizer";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { requiredRule } from "@/lib/rules/requiredRule";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { createFileName, FileType } from "@/lib/utility/string-helper";
import DocumentTemplateMixin from "@/mixins/DocumentTemplateMixin.vue";
import { ISignDocument } from "@/models/sign-document.entity";
import { SignCreateSignDtoGen } from "@/services/sign/v1/data-contracts";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { SignCreateModule } from "@/store/modules/sign-create.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import VueSignaturePad from "vue-signature-pad";
import { isSignatureToken } from "@/lib/signature-token.utils";
import SignFormEditorInputList from "./SignFormEditorInputList.vue";
const pdfMeGenerator = () => import("@pdfme/generator");

@Component({
  components: { Tooltip, SignFormEditorInputList },
  filters: { simpleDoubleDigitDate }
})
export default class SignFormEditorControls extends mixins(DocumentTemplateMixin) {
  @Prop({ default: false })
  row!: boolean;

  @Prop()
  pageCount!: number;

  @Ref("pdf")
  pdf!: HTMLIFrameElement;

  @Ref("signaturePad")
  signaturePad!: VueSignaturePad;

  @Prop()
  document!: ISignDocument;

  @Prop({ default: false })
  isMobile!: boolean;

  currentPageNumber = 0;

  highlightedImage = -1;

  isValid = true;

  terms = false;
  withdrawal = false;

  sheet = false;
  currentStep = 1;

  signature: SignCreateSignDtoGen = {
    lastName: ReportModule.user.lastName || "",
    firstName: ReportModule.user.firstName || "",
    location: ""
  };

  isLoading = false;
  isSaving = false;

  isError = false;

  isPdfLoaded = false;

  errorTitle = "sign.Sign.error.title";

  /**
   * Somehow the sign pad does not work initially. It does not show the drawings
   * a few ms after starting the sign pad the key is incremented, somehow this makes the sign pad work reliably
   */
  signPadMotivationalKey = 0;

  isSigned = false;

  isGenerationLoading = false;

  generatedPages: string[] = [];

  clientHeight = document.documentElement.clientHeight;
  clientWidth = document.documentElement.clientWidth;

  get locationText() {
    if (this.signature.location) {
      return `${this.signature.location}, ${simpleDoubleDigitDate(new Date().toISOString())}`;
    }

    return simpleDoubleDigitDate(new Date().toISOString());
  }

  get partner() {
    return PartnerModule.partner;
  }

  get isErrorGetter() {
    return this.isError;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get partnerColorDarkmode() {
    return this.$vuetify.theme.dark ? "white" : this.color;
  }

  get signRequest() {
    return SignCreateModule.request;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get overlayStyle() {
    if (this.$vuetify.theme.dark) {
      return "background-color:#1E1E1E;";
    } else {
      return "color: rgba(0, 0, 0, 0.6);";
    }
  }

  get widthSignature() {
    if (this.isXsBreakpointOrDown) {
      return this.clientWidth - 45;
    }

    if (this.isBreakpointOrDown) {
      return 150 * 2.275;
    }

    return 200 * 2.275;
  }

  get heightSignature() {
    return `${this.widthSignature / 2.275}px`;
  }

  get widthStyle() {
    return `width: ${this.widthSignature}px`;
  }

  get firstNameSmallClass() {
    if (this.isBreakpointOrDown) {
      return "pb-0";
    } else {
      return "";
    }
  }

  get tokenListErrors() {
    if (!this.document || !this.document.tokens || !Array.isArray(this.document.tokens)) {
      return "";
    }

    const errors: string[] = [];
    let page = 0;
    for (const tokens of this.document.tokens) {
      page++;

      if (!Array.isArray(tokens)) {
        continue;
      }

      const missing = tokens.filter(
        token => token && !isSignatureToken(token.token) && !token.value && token.isEditable && token.isRequired
      ).length;

      if (missing) {
        errors.push(String(this.$t("sign.DocumentTemplateDetailTokenList.missing", { count: missing, page })));
      }
    }
    return errors.join("<br/>");
  }

  get tokenListErrorsText() {
    return this.tokenListErrors.replace(/<br\/>/g, " ");
  }

  hasEditableTokens = false;

  get isXsBreakpointOrDown() {
    return this.clientWidth < 412;
  }

  get isBreakpointOrDown() {
    return this.clientWidth < 1048;
  }

  get isSignDisabled() {
    // On mobile steppe rhandles validation so sign button is never disabled
    if (this.isMobile) {
      return false;
    }

    // On desktop, disable if there are required token errors, because sign form only has SIGN field not FORM with validation
    return !!this.tokenListErrors;
  }

  async download() {
    const generated = await this.generatePreview();
    const blob = new Blob([generated], {
      type: "application/pdf"
    });
    window.open(window.URL.createObjectURL(blob), "_blank");
  }

  setHasEditableTokens() {
    if (!this.document || !this.document.tokens?.length) {
      this.hasEditableTokens = false;
      return;
    }

    // On desktop, skip the form step - users can see the form in the sidebar
    if (!this.isMobile) {
      this.hasEditableTokens = false;
      return;
    }

    // On mobile, show form step if there are editable tokens
    this.hasEditableTokens = this.document.tokens.some(
      tokens =>
        Array.isArray(tokens) && tokens.some(token => token && !isSignatureToken(token.token) && token.isEditable)
    );
  }

  start() {
    this.currentStep = this.hasEditableTokens ? 1 : 2;
    this.currentPageNumber = 0;
    this.sheet = true;

    setTimeout(() => {
      this.signPadMotivationalKey++;
    }, 100);
  }
  setCurrentPage(pageNumber: number) {
    this.currentPageNumber = pageNumber;
  }

  showImage(index: number) {
    this.highlightedImage = index;
    this.$nextTick(() => {
      const image = document.getElementById(`image${index}`);
      image?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  hideImage() {
    this.highlightedImage = -1;
  }

  onResize() {
    this.clientHeight = document.documentElement.clientHeight;
    this.clientWidth = document.documentElement.clientWidth;
  }

  async generatePreview() {
    this.isGenerationLoading = true;

    const schemas: any[] = [];
    let inputs = {};

    for (const documentTokensPage of this.document.tokens ?? []) {
      let schemaPage = {};

      let page = 0;
      for (const documentToken of documentTokensPage) {
        const key = this.getKey(documentToken, page);
        page++;
        schemaPage = {
          ...schemaPage,
          [key]: {
            type: "text",
            position: { x: documentToken.coordinates.x, y: documentToken.coordinates.y },
            width: documentToken.coordinates.w,
            height: documentToken.coordinates.h,
            fontSize: documentToken.coordinates.fontSize
          }
        };

        inputs = { ...inputs, [key]: documentToken.value ?? "" };
      }

      schemas.push(schemaPage);
    }

    const basePdf = this.document.url;

    const template = {
      basePdf: basePdf,
      schemas: schemas ?? []
    };

    const pdfMeGen = await pdfMeGenerator();

    // PDF with tokens
    const generated = await pdfMeGen.generate({
      template: {
        basePdf: template.basePdf,
        schemas: template.schemas
      },
      inputs: [inputs]
    });

    this.isGenerationLoading = false;

    return generated;
  }

  onBegin() {
    this.isSigned = true;
  }

  cancel() {
    this.clear();

    this.signature.firstName = "";
    this.signature.lastName = "";
    this.signature.location = "";

    this.terms = false;
  }

  clear() {
    this.isSigned = false;
    this.signaturePad.clearSignature();
  }

  load() {
    this.isPdfLoaded = true;
  }

  send() {
    const { isEmpty, data } = this.signaturePad.saveSignature();

    if (isEmpty) {
      this.$toast.error(this.$t("sign.Sign.error.missingSignature"));
      this.$log.error("Missing Signature");
      return;
    }

    this.isSaving = true;

    const fileName = createFileName(this.signature.lastName, FileType.PNG);
    const blob = dataURItoBlob(data);
    const image = new File([blob], fileName, { type: blob.type });

    this.signature.image = image;

    this.$emit("sign", this.signature);
  }

  async mounted() {
    this.isLoading = true;
    this.setHasEditableTokens();

    setTimeout(() => {
      this.signPadMotivationalKey++;
    }, 100);
  }
}
